import React from 'react';
import PropTypes from 'prop-types';
import style from '../index.css';
import { rel } from '../../../utils/rel';
import errorBoundary from '@ifeng-fe/errorBoundary';

import { formatUrl } from '../../../utils/formatUrl';

class YuanChuangNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const navDom = [];

        content.forEach((item, index) => {
            let result = [];
            const line = <span key={`s${item.id}_${item.creator}_${item.newsTime}`}> | </span>;

            const itemDom = (
                <a
                    key={`a${item.id}_${item.creator}_${item.newsTime}`}
                    href={formatUrl(item.url)}
                    target="_blank"
                    rel={rel}>
                    {item.title}
                </a>
            );

            if (index === 0) {
                result = [itemDom];
            } else {
                result = [line, itemDom];
            }

            navDom.push(result);
        });

        return <div className={style.breadcrumbs}>{navDom}</div>;
    }
}
export default errorBoundary(YuanChuangNav);
